var component = require('../../../lib/js/component.js');
var Form = require('../forms/form.js');
var constants = require('../forms/constants.js');
var AdobeLaunch = require('../../../lib/js/adobelaunch');

var FormLogin = function () {
    this.initialize = function (el, options) {
        this.options = options || {};
        this.$form = this.find('.Form--accountLogin');
        this.$form.attach(Form).on(constants.FORM_AJAX_SUBMIT, this.handleFormSubmissionLogin.bind(this));
    };

    this.handleFormSubmissionLogin = function (event, form) {
        // Validate that CSRF token exists before proceeding
        var tokenInput = this.$form.find('input[name="__RequestVerificationToken"]');
        var token = tokenInput.val();
    
        if (!token) {
            console.warn('No CSRF token found in form. Aborting login.');
            this.showError('Security validation failed. Please refresh the page and try again.');
            return; 
        }
    
        $.ajax({
            method: form.options.method,
            url: form.options.action,
            data: form.data,
            dataType: "json"
        }).done(function (data) {
            if (data) {
                if (data.Success && data.UserId) {
                    AdobeLaunch.pushUserEvent(AdobeLaunch.USER_SIGNED_IN_EVENT_NAME, data.UserId);
                }
    
                location.href = data.RedirectUrl;
            } else {
                this.showError('Login failed. Please check your credentials and try again.');
            }
        }.bind(this)) 
        .fail(function (jqXHR, textStatus, errorThrown) {
            console.error('Login request failed:', textStatus, errorThrown);
            var message = 'Login failed. Please try again.';
    
            if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
                message = jqXHR.responseJSON.error;
            }
    
            this.showError(message);
        }.bind(this)); // Bind `this` to ensure `this.showError()` works
    };
    
    this.showError = function (message) {
        var $messageTarget = this.$form.find('.FormSubmit .inline-message .error-target');
        $messageTarget.text(message);
        this.$form.find('.inline-message').attr('aria-hidden', false).show();
    };
};

module.exports = component(FormLogin);
